import { getClient, getDefaultPropfind, getRootPath, resultToNode } from '@nextcloud/files/dav';
export const client = getClient();
export const fetchNode = async (path) => {
    const propfindPayload = getDefaultPropfind();
    const result = await client.stat(`${getRootPath()}${path}`, {
        details: true,
        data: propfindPayload,
    });
    return resultToNode(result.data);
};
